/* @flow */
import React, { type Node, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_SIMILAR_APART_SORT } from '../../../../constants';
import type { TRootState } from '../../../../types/rootState';
import type { TDispatch } from '../../../../types/core';
import { serviceCheckIcon } from '../../../Icons';
import { sortIcon } from './SortIcon';
import { IconInSelect, SortBtnItem, SimilarBtnsWrapper, CheckIcon } from './styles';
import { Popover } from '../../../Tooltip/Tooltip';

const SortingSimilarBtn = (): Node => {
	const similarSort: string = useSelector((state: TRootState) => state.apartment.similarSort);
	const dispatch: TDispatch = useDispatch();

	const [openSortOptions, setOpenSortOptions] = useState(false);

	const SORT_SIMILAR = [
		{
			value: 'FLOOR_DESC',
			label: 'Этаж выше',
		},
		{
			value: 'FLOOR_ASC',
			label: 'Этаж ниже',
		},
		{
			value: 'PRICE_DESC',
			label: `Цена выше`,
		},
		{
			value: 'PRICE_ASC',
			label: `Цена ниже`,
		},
	];

	const handleToggleOptions = () => {
		setOpenSortOptions(!openSortOptions);
	};

	const handleChangeSorting = (value) => {
		dispatch({ type: SET_SIMILAR_APART_SORT, payload: value });
		handleToggleOptions();
	};

	const SIMILAR_BTNS_CONTENT = (
		<SimilarBtnsWrapper>
			{SORT_SIMILAR.map((value) => (
				<SortBtnItem
					key={`Sort${value.value}`}
					onClick={() => handleChangeSorting(value.value)}
					isActive={value.value === similarSort}
				>
					{value.label}
					{value.value === similarSort && <CheckIcon viewBox="0 0 16 16">{serviceCheckIcon}</CheckIcon>}
				</SortBtnItem>
			))}
		</SimilarBtnsWrapper>
	);

	return (
		<Popover
			content={SIMILAR_BTNS_CONTENT}
			theme="selectionNotices"
			placement="left-start"
			visible={openSortOptions}
			onClickOutside={handleToggleOptions}
		>
			<IconInSelect viewBox="0 0 34 34" onClick={handleToggleOptions}>
				{sortIcon}
			</IconInSelect>
		</Popover>
	);
};

SortingSimilarBtn.defaultProps = {
	sort: false,
	isSorted: undefined,
	area: '',
	position: 'flex-start',
	onClick: undefined,
	dataQa: null,
};

export default SortingSimilarBtn;
